var map = {
	"./ar/easy/text.json": 2266,
	"./cs/easy/text.json": 29133,
	"./cy/easy/text.json": 20841,
	"./da/easy/text.json": 42719,
	"./de/easy/text.json": 28543,
	"./en/easy/text.json": 80770,
	"./es/easy/text.json": 92351,
	"./fi/easy/text.json": 57930,
	"./fr/easy/text.json": 35598,
	"./he/easy/text.json": 87718,
	"./hi/easy/text.json": 83948,
	"./hr/easy/text.json": 71123,
	"./hu/easy/text.json": 934,
	"./it/easy/text.json": 42951,
	"./ja/easy/text.json": 73534,
	"./kk/easy/text.json": 58572,
	"./kn/easy/text.json": 41763,
	"./ko/easy/text.json": 19876,
	"./ml/easy/text.json": 48991,
	"./mr/easy/text.json": 20163,
	"./nl/easy/text.json": 80296,
	"./pl/easy/text.json": 40694,
	"./pt/easy/text.json": 37545,
	"./ro/easy/text.json": 18158,
	"./ru/easy/text.json": 7157,
	"./sh/easy/text.json": 99378,
	"./sk/easy/text.json": 49774,
	"./sr/easy/text.json": 61165,
	"./sv/easy/text.json": 37888,
	"./ta/easy/text.json": 83484,
	"./te/easy/text.json": 6466,
	"./vi/easy/text.json": 68732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41337;